// extracted by mini-css-extract-plugin
module.exports = {"tagsWrapper":"member-tags_tagsWrapper__mA-j3","tagElement":"member-tags_tagElement__3rpUu","showMore":"member-tags_showMore__WcSfE"};